module.exports = __webpack_public_path__ + "img/location_pin.5642a4c6.svg";